import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { doesBotHaveMutationsSelector } from '../selectors/selectors'

export function useDoesBotHaveMutations() {
  return useSelector<RootState, boolean>(doesBotHaveMutationsSelector)
}
